import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isEditOrganizationRequestFailure({ uuid }) {
      const state = getState().find(({ planzone }) => planzone.uuid === uuid);

      return state ? state.request.isFailure : false;
    },
    isEditOrganizationRequestPending({ uuid }) {
      const state = getState().find(({ planzone }) => planzone.uuid === uuid);

      return state ? state.request.isPending : false;
    },
    isEditOrganizationRequestSuccess({ uuid }) {
      const state = getState().find(({ planzone }) => planzone.uuid === uuid);

      return state ? state.request.isSuccessful : false;
    },
  };
}

export { createSelector };
